import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class LocationSelect extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let options = [];
    const { availablePractices } = this.props;
    if (availablePractices.length > 0) {
        availablePractices.map(practice => {
        options.push({ value: practice.eventCategoryId, label: practice.name });
      });
    }


    return (
      <div>
        <div>
          <label>Standort*</label>
        </div>
        <div>
          <Select
             className="taxi-dropdown"
             name={this.props.name}
             value={this.props.selectedOption.value ? this.props.selectedOption : undefined}
             onChange={this.props.onChange}
             options={options}
             placeholder={this.props.placeholder}
             clearable={false}
           />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationSelect.js